import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import LocationSection from './components/LocationSection'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import { ActionsWrapper, Content } from 'themes/views/modals'
import { ReduxEntitySelect, ReduxInput, ReduxSwitch } from 'components/FormElements/ReduxForm'
// constants
import { ENTITIES } from 'constants/entities'
// types
import { Forms } from 'constants/forms'
import { Place } from 'components/FormElements/LocationPicker'
import { IOption } from 'components/FormElements/Select'
import { DocumentNode } from 'graphql/language'
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// utils
import { required } from 'utils/validators'
import { startCase, toLower } from 'lodash'

export interface BusinessEntityFields {
  lat?: string
  code: string
  long?: string
  active: boolean
  parent: IOption
  address?: { value: Place }
  description: string
}

interface Props {
  query: DocumentNode
  onSubmit: (data: BusinessEntityFields) => Promise<void>
  entityId?: string
  hideModal: () => void
  getOptions: (data: any) => void
  entityType: keyof typeof ENTITIES
  handleSearch: ({ search, refetch }: { search: string; refetch: () => Promise<void> }) => void
}

const BusinessEntityForm: React.FC<InjectedFormProps<BusinessEntityFields, Props> & Props> = ({
  query,
  valid,
  onSubmit,
  entityId,
  hideModal,
  submitting,
  getOptions,
  entityType,
  handleSearch,
  handleSubmit
}) => {
  const entity = startCase(toLower(entityType))

  const handleFormSubmit = async (data: BusinessEntityFields) => {
    await onSubmit(data)
  }

  const prepareOptions = (options: IOption[]) => options.filter(({ value }) => value !== entityId)

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Content>
        <Grid container direction={'column'} spacing={2} wrap={'nowrap'}>
          <ReduxSwitch name={'active'} label={'Active'} justifyContent={'flex-start'} />
          <ReduxInput multiline validate={required} name={'description'} label={`${entity} Description`} />
          <ReduxInput name={'code'} label={`${entity} Code`} validate={required} />
          <ReduxEntitySelect
            name='parent'
            query={query}
            getOptions={getOptions}
            handleSearch={handleSearch}
            prepareOptions={prepareOptions}
            label={`${entity} Reporting to`}
          />
          {entityType === ENTITIES.LOCATION && <LocationSection />}
        </Grid>
      </Content>
      <ActionsWrapper>
        <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE} type={'submit'} isLoading={submitting} disabled={!valid}>
          {entityId ? 'Save' : 'Create'}
        </Button>
        <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal}>
          Cancel
        </Button>
      </ActionsWrapper>
    </form>
  )
}

export default reduxForm<BusinessEntityFields, Props>({
  form: Forms.BUSINESS_ACTIVITY_FORM,
  enableReinitialize: true
})(BusinessEntityForm)
